// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assets-form {
  max-width: 600px;
  /* / height: 420px; / */
  height: auto;
  margin: 0;
  /* / background-color: #f5f5f5; / */
  border: 1px solid rgb(90, 179, 193);
  background-image: linear-gradient(rgb(248, 248, 248), rgb(225, 240, 222));
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  /* / min-height: 500px; / */
  /* / position: relative; / */
  margin-top: 20px;
  padding: 7px;

  border-radius: 20px;
  & .form-header {
    /* / background-color: #b7151588; / */
    color: black;
    padding: 10px;
    width: 100%;
    /* width: 400px; */
    /* / margin-top: 10px; / */
    /* / text-align: left; / */
  }
  & .form-header h2 {
    margin: -22px;
    /* / background-color: #007bff; / */
    padding: 5px;
    text-align: center;
    /* margin-left: 40px; */
    margin-top: 20px;
    font-size: 1.4rem;
  }
}
.form-body {
  flex-grow: 1;
  padding: 16px;
  display: flex;
}

.form-left {
  flex: 2 1;
  padding-right: 50px;
  margin-left: 33px;
}

.form-right {
  flex: 1 1;
}

.category {
  width: 100%;
  color: #c7c8cc;
}

/* .form-group input {
  padding: 1px;
} */

.form-group {
  /* / background-color: #007bff; / */
  margin-bottom: 5px;
  padding: 5px;
  position: relative;
  /* / display: inline-block; / */
}

.form-footer {
  /* / height: 80px; / */
  /* / padding: 5px; / */
  text-align: right;
  /* / display: flex; / */
  margin-right: 15%;
  /* / background-color: #007bff; / */
  margin-top: -17px;
}

.submit-btn {
  font-size: 18px;
  padding: 1px 2px;
  margin-left: 10px;
  margin-bottom: 10px;
  width: 100px;
  height: 41px;
  color: white;
  background-color: rgb(159, 211, 192);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.submit-btn,
.cancel-btn:hover {
  cursor: pointer;
}
.cancel-btn {
  font-size: 18px;
  padding: 10px 25px;
  margin-left: 5px;
  width: 100px;
  height: 40px;
  color: black;
  background-color: rgb(208, 208, 208);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  /* / transition: background-color 0.3s ease; / */
}

.form-group input,
.form-group select {
  font-family: inherit;
  font-size: 12px;
  font-weight: 1.2rem;
}
.form-group input[type="text"],
.form-group select {
  padding: 14px;
  border: none;
  background-color: white;
  box-sizing: border-box;
  border-radius: 15px;
}
.form-group input[type="text"]:focus {
  outline: none;
  border-color: rgb(47, 47, 48);
  box-shadow: 0 0 8px rgba(90, 90, 91, 0.6);
}
.form-group input[type="date"]:focus {
  outline: none;
  border-color: rgb(47, 47, 48);
  box-shadow: 0 0 8px rgba(90, 90, 91, 0.6);
}
.text_area:focus {
  outline: none;
  border-color: rgb(47, 47, 48);
  box-shadow: 0 0 8px rgba(90, 90, 91, 0.6);
}
.text_area::placeholder {
  color: rgb(74, 74, 74);
}
.form-group input[type="date"] {
  border: none;
  border-radius: 13px;
  width: 100%;
  font-size: 13px;
}
.form-group input[type="date"],
.form-group select:hover {
  cursor: pointer;
}
input[type="text"]::placeholder {
  /* / background-color: rgb(7, 22, 22); / */
  padding: 10px;
}
/* / Adjust textarea height separately if needed / */

.text_area {
  height: 80px;
  width: 350px;
  border: none;
  border-radius: 13px;
  font-size: 13px;
  /* / resize: vertical; / */
}
.text_area::placeholder {
  padding-top: 30px;
  padding: 30px;
}
#comments {
  padding-left: 10px;
}

.crossbtn {
  position: relative;
  height: 50px;
  width: 50px;
  /* top: 75px;
  right: 60px;
  transform: translateY(-75%);
  border: none; */
}
.mainicon {
  position: absolute;
  top: 40%;
  left: 30%;
}
#category {
  appearance: none;
}
/* .selectIcon {
  position: absolute;
} */

/* .selectIcon {
  position: absolute;

  top: 56%;
  right: 7%;
  transform: translateY(-45%);
  pointer-events: none;
} */

#assetdrop {
  border-radius: 10px;
  background-color: white;
  border: none;
  padding: 14px;
  font-size: 12px;
  margin-bottom: 14px;
}
.form-footer {
  margin-top: 0px !important;
  text-align: right;
}
#assetdrop:hover {
  cursor: pointer;
}
.crossIcon span:hover {
  cursor: pointer;
}

@media screen and (max-width: 767px) {
  .assets-form {
    width: 90vw; /* Use viewport width for responsiveness */
    margin: 20px auto; /* Center the form on the screen */
    padding: 15px;
    box-sizing: border-box;
  }

  .assets-form .form-header {
    width: 100%;
    padding: 10px 0;
  }

  .assets-form .form-header h2 {
    margin: 0;
    padding: 5px;
    font-size: 1.2rem;
    text-align: center; /* Center heading on mobile */
  }

  .form-body {
    flex-direction: column; /* Stack form sections vertically */
    padding: 0;
  }

  .form-left,
  .form-right {
    padding-right: 0;
    margin-left: 0;
    width: 100%;
  }

  .text_area {
    width: 100%; /* Make textarea full-width */
  }

  .form-footer {
    margin: 20px 0 0;
    padding: 0;
    display: flex;
    flex-direction: column; /* Stack buttons for easier tapping */
    gap: 10px;
  }

  .submit-btn,
  .cancel-btn {
    width: 100%; /* Make buttons take full width */
    margin: 0;
  }
  .form-group input {
    margin-bottom: 10px;
  }
}

/* .assets-form {
    max-width: 600px;
    margin: 0 auto;
    background-color: #f5f5f5;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    min-height: 90vh; 
    margin-top: 20px;
    & .form-header {
        background-color: #f0f0f088;
        color: black;
        padding: 20px;
        text-align: left;
    }
    &   
    .form-header h2 {
      margin: 0;
    } 
      
  }
  .form-body {
    flex-grow: 1;
    padding: 20px;
    display: flex; 
    
  }
  
  .form-left {
    flex: 2;
    padding-right: 50px;
  }
  
  .form-right {
    flex: 1;
  }
  
  .form-group {
    margin-bottom: 20px; 
   


  }
  .category{
    width: 90%;
    color:#C7C8CC;
  }
  
  .form-group label {
    display: flex;
    margin-bottom: 5px;
  }
  
  .form-group input[type="text"],
  .form-group textarea,
  .form-group select {
    width: 100%;  
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: white; 

  }
  
  .form-group input[type="checkbox"] {
    margin-right: 5px; 
     width: 20px;
  }
  
  .form-group input[type="checkbox"] + label {
    display: inline;
    vertical-align: middle; 
     width: 20px; 
  }
  
  .form-footer {
   padding: 20px;
    text-align: right;
    display: flex;
    margin-left: 60%;
  }
  
  label{
    color:#C7C8CC;
  }
  #category{
    
    color:#C7C8CC;
    
    
  }
   #first-div{
      width: 100%;
  }
  #second-div{
    width:100%;
  }
  #third-div{
    width:100%; 
   }  
  
  
   .submit-btn {
    padding: 10px 20px;
    margin-left: 10px;
    color: #f0f0f0;
    background-color: #0057b3d5;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .submit-btn:hover {
    background-color: rgb(112, 167, 222);
  }
  .cancel-btn{
    padding: 10px 25px;
    margin-left: 10px;
    color: black;
    background-color:#EEEEEE;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .cancel-btn:hover{
    background-color: #d8d3d3;
  }
  
  .form-group input[type="text"]:focus,
  .form-group textarea:focus,
  .form-group select:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
  }
  
  .form-group input::placeholder,
  .form-group textarea::placeholder {
    color: #999;
  }
  
  .form-group input,
  .form-group textarea,
  .form-group select,
  .submit-btn {
    font-family: inherit;
    font-size: 16px;
    
  }  
 .form-group input[type="text"],
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 10px; 
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  height: 40px; 
  box-sizing: border-box; 
}

.form-group textarea {
  height: 100px; 
  resize: vertical; 
}

 */
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/utils/AssetsForm/AssetsForm.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,mCAAmC;EACnC,mCAAmC;EACnC,yEAAyE;EACzE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;;EAEZ,mBAAmB;EACnB;IACE,qCAAqC;IACrC,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,mCAAmC;IACnC,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;AACf;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;;EAEE,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,aAAa;AACf;AACA,oDAAoD;;AAEpD;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX;;;iBAGe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;;GAEG;;AAEH;;;;;;;GAOG;;AAEH;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,WAAW,EAAE,0CAA0C;IACvD,iBAAiB,EAAE,kCAAkC;IACrD,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,kBAAkB,EAAE,6BAA6B;EACnD;;EAEA;IACE,sBAAsB,EAAE,mCAAmC;IAC3D,UAAU;EACZ;;EAEA;;IAEE,gBAAgB;IAChB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW,EAAE,6BAA6B;EAC5C;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,sBAAsB,EAAE,qCAAqC;IAC7D,SAAS;EACX;;EAEA;;IAEE,WAAW,EAAE,iCAAiC;IAC9C,SAAS;EACX;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwKE","sourcesContent":[".assets-form {\n  max-width: 600px;\n  /* / height: 420px; / */\n  height: auto;\n  margin: 0;\n  /* / background-color: #f5f5f5; / */\n  border: 1px solid rgb(90, 179, 193);\n  background-image: linear-gradient(rgb(248, 248, 248), rgb(225, 240, 222));\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  /* / min-height: 500px; / */\n  /* / position: relative; / */\n  margin-top: 20px;\n  padding: 7px;\n\n  border-radius: 20px;\n  & .form-header {\n    /* / background-color: #b7151588; / */\n    color: black;\n    padding: 10px;\n    width: 100%;\n    /* width: 400px; */\n    /* / margin-top: 10px; / */\n    /* / text-align: left; / */\n  }\n  & .form-header h2 {\n    margin: -22px;\n    /* / background-color: #007bff; / */\n    padding: 5px;\n    text-align: center;\n    /* margin-left: 40px; */\n    margin-top: 20px;\n    font-size: 1.4rem;\n  }\n}\n.form-body {\n  flex-grow: 1;\n  padding: 16px;\n  display: flex;\n}\n\n.form-left {\n  flex: 2;\n  padding-right: 50px;\n  margin-left: 33px;\n}\n\n.form-right {\n  flex: 1;\n}\n\n.category {\n  width: 100%;\n  color: #c7c8cc;\n}\n\n/* .form-group input {\n  padding: 1px;\n} */\n\n.form-group {\n  /* / background-color: #007bff; / */\n  margin-bottom: 5px;\n  padding: 5px;\n  position: relative;\n  /* / display: inline-block; / */\n}\n\n.form-footer {\n  /* / height: 80px; / */\n  /* / padding: 5px; / */\n  text-align: right;\n  /* / display: flex; / */\n  margin-right: 15%;\n  /* / background-color: #007bff; / */\n  margin-top: -17px;\n}\n\n.submit-btn {\n  font-size: 18px;\n  padding: 1px 2px;\n  margin-left: 10px;\n  margin-bottom: 10px;\n  width: 100px;\n  height: 41px;\n  color: white;\n  background-color: rgb(159, 211, 192);\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.submit-btn,\n.cancel-btn:hover {\n  cursor: pointer;\n}\n.cancel-btn {\n  font-size: 18px;\n  padding: 10px 25px;\n  margin-left: 5px;\n  width: 100px;\n  height: 40px;\n  color: black;\n  background-color: rgb(208, 208, 208);\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  /* / transition: background-color 0.3s ease; / */\n}\n\n.form-group input,\n.form-group select {\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 1.2rem;\n}\n.form-group input[type=\"text\"],\n.form-group select {\n  padding: 14px;\n  border: none;\n  background-color: white;\n  box-sizing: border-box;\n  border-radius: 15px;\n}\n.form-group input[type=\"text\"]:focus {\n  outline: none;\n  border-color: rgb(47, 47, 48);\n  box-shadow: 0 0 8px rgba(90, 90, 91, 0.6);\n}\n.form-group input[type=\"date\"]:focus {\n  outline: none;\n  border-color: rgb(47, 47, 48);\n  box-shadow: 0 0 8px rgba(90, 90, 91, 0.6);\n}\n.text_area:focus {\n  outline: none;\n  border-color: rgb(47, 47, 48);\n  box-shadow: 0 0 8px rgba(90, 90, 91, 0.6);\n}\n.text_area::placeholder {\n  color: rgb(74, 74, 74);\n}\n.form-group input[type=\"date\"] {\n  border: none;\n  border-radius: 13px;\n  width: 100%;\n  font-size: 13px;\n}\n.form-group input[type=\"date\"],\n.form-group select:hover {\n  cursor: pointer;\n}\ninput[type=\"text\"]::placeholder {\n  /* / background-color: rgb(7, 22, 22); / */\n  padding: 10px;\n}\n/* / Adjust textarea height separately if needed / */\n\n.text_area {\n  height: 80px;\n  width: 350px;\n  border: none;\n  border-radius: 13px;\n  font-size: 13px;\n  /* / resize: vertical; / */\n}\n.text_area::placeholder {\n  padding-top: 30px;\n  padding: 30px;\n}\n#comments {\n  padding-left: 10px;\n}\n\n.crossbtn {\n  position: relative;\n  height: 50px;\n  width: 50px;\n  /* top: 75px;\n  right: 60px;\n  transform: translateY(-75%);\n  border: none; */\n}\n.mainicon {\n  position: absolute;\n  top: 40%;\n  left: 30%;\n}\n#category {\n  appearance: none;\n}\n/* .selectIcon {\n  position: absolute;\n} */\n\n/* .selectIcon {\n  position: absolute;\n\n  top: 56%;\n  right: 7%;\n  transform: translateY(-45%);\n  pointer-events: none;\n} */\n\n#assetdrop {\n  border-radius: 10px;\n  background-color: white;\n  border: none;\n  padding: 14px;\n  font-size: 12px;\n  margin-bottom: 14px;\n}\n.form-footer {\n  margin-top: 0px !important;\n  text-align: right;\n}\n#assetdrop:hover {\n  cursor: pointer;\n}\n.crossIcon span:hover {\n  cursor: pointer;\n}\n\n@media screen and (max-width: 767px) {\n  .assets-form {\n    width: 90vw; /* Use viewport width for responsiveness */\n    margin: 20px auto; /* Center the form on the screen */\n    padding: 15px;\n    box-sizing: border-box;\n  }\n\n  .assets-form .form-header {\n    width: 100%;\n    padding: 10px 0;\n  }\n\n  .assets-form .form-header h2 {\n    margin: 0;\n    padding: 5px;\n    font-size: 1.2rem;\n    text-align: center; /* Center heading on mobile */\n  }\n\n  .form-body {\n    flex-direction: column; /* Stack form sections vertically */\n    padding: 0;\n  }\n\n  .form-left,\n  .form-right {\n    padding-right: 0;\n    margin-left: 0;\n    width: 100%;\n  }\n\n  .text_area {\n    width: 100%; /* Make textarea full-width */\n  }\n\n  .form-footer {\n    margin: 20px 0 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column; /* Stack buttons for easier tapping */\n    gap: 10px;\n  }\n\n  .submit-btn,\n  .cancel-btn {\n    width: 100%; /* Make buttons take full width */\n    margin: 0;\n  }\n  .form-group input {\n    margin-bottom: 10px;\n  }\n}\n\n/* .assets-form {\n    max-width: 600px;\n    margin: 0 auto;\n    background-color: #f5f5f5;\n    border-radius: 5px;\n    display: flex;\n    flex-direction: column;\n    min-height: 90vh; \n    margin-top: 20px;\n    & .form-header {\n        background-color: #f0f0f088;\n        color: black;\n        padding: 20px;\n        text-align: left;\n    }\n    &   \n    .form-header h2 {\n      margin: 0;\n    } \n      \n  }\n  .form-body {\n    flex-grow: 1;\n    padding: 20px;\n    display: flex; \n    \n  }\n  \n  .form-left {\n    flex: 2;\n    padding-right: 50px;\n  }\n  \n  .form-right {\n    flex: 1;\n  }\n  \n  .form-group {\n    margin-bottom: 20px; \n   \n\n\n  }\n  .category{\n    width: 90%;\n    color:#C7C8CC;\n  }\n  \n  .form-group label {\n    display: flex;\n    margin-bottom: 5px;\n  }\n  \n  .form-group input[type=\"text\"],\n  .form-group textarea,\n  .form-group select {\n    width: 100%;  \n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: white; \n\n  }\n  \n  .form-group input[type=\"checkbox\"] {\n    margin-right: 5px; \n     width: 20px;\n  }\n  \n  .form-group input[type=\"checkbox\"] + label {\n    display: inline;\n    vertical-align: middle; \n     width: 20px; \n  }\n  \n  .form-footer {\n   padding: 20px;\n    text-align: right;\n    display: flex;\n    margin-left: 60%;\n  }\n  \n  label{\n    color:#C7C8CC;\n  }\n  #category{\n    \n    color:#C7C8CC;\n    \n    \n  }\n   #first-div{\n      width: 100%;\n  }\n  #second-div{\n    width:100%;\n  }\n  #third-div{\n    width:100%; \n   }  \n  \n  \n   .submit-btn {\n    padding: 10px 20px;\n    margin-left: 10px;\n    color: #f0f0f0;\n    background-color: #0057b3d5;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .submit-btn:hover {\n    background-color: rgb(112, 167, 222);\n  }\n  .cancel-btn{\n    padding: 10px 25px;\n    margin-left: 10px;\n    color: black;\n    background-color:#EEEEEE;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  .cancel-btn:hover{\n    background-color: #d8d3d3;\n  }\n  \n  .form-group input[type=\"text\"]:focus,\n  .form-group textarea:focus,\n  .form-group select:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 0 2px rgba(0,123,255,0.25);\n  }\n  \n  .form-group input::placeholder,\n  .form-group textarea::placeholder {\n    color: #999;\n  }\n  \n  .form-group input,\n  .form-group textarea,\n  .form-group select,\n  .submit-btn {\n    font-family: inherit;\n    font-size: 16px;\n    \n  }  \n .form-group input[type=\"text\"],\n.form-group textarea,\n.form-group select {\n  width: 100%;\n  padding: 10px; \n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: white;\n  height: 40px; \n  box-sizing: border-box; \n}\n\n.form-group textarea {\n  height: 100px; \n  resize: vertical; \n}\n\n */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
